<odq-welcome
  [model]="model"
  [inactiveMemberForSubscription]="inactiveMemberForSubscription">

</odq-welcome>

@if (model?.societies?.length>=2) {
  <odq-surplus-info
    [model]="model"
    >
  </odq-surplus-info>
}

@if (model?.premiumMinimum && model?.showPremiumMinimum) {
  <odq-premium-minimum
    [model]="model"
    >
  </odq-premium-minimum>
}


